import { useForm, defineRule, configure } from 'vee-validate';
import { required, email, max } from '@vee-validate/rules';
import { localize, setLocale } from '@vee-validate/i18n';
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import { useRoute } from 'vue-router';

defineRule('required', required);
defineRule('email', email);
defineRule('max', max);

export const useContactForm = () => {
  const { t, locale, messages } = useI18n();

  const { handleSubmit } = useForm();

  const fields: { [key: string]: any } = {
    name: {
      type: 'text',
      name: 'name',
      label: t('contact.form.name'),
      maxLength: 100,
      rules: 'required|max:100'
    },
    email: {
      type: 'email',
      name: 'email',
      label: t('contact.form.email'),
      maxLength: 100,
      rules: 'required|email|max:100'
    },
    companyName: {
      type: 'text',
      name: 'companyName',
      label: t('contact.form.companyName'),
      maxLength: 100,
      rules: 'required|max:100'
    },
    phone: {
      type: 'text',
      name: 'phone',
      label: t('contact.form.phone'),
      maxLength: 20,
      rules: 'required|max:20'
    },
    vatNumber: {
      type: 'text',
      name: 'vatNumber',
      label: t('contact.form.vatNumber'),
      maxLength: 20,
      rules: 'max:20'
    },
    zipCode: {
      type: 'text',
      name: 'zipCode',
      label: t('contact.form.zipCode'),
      maxLength: 10,
      rules: 'max:10'
    },
    city: {
      type: 'text',
      name: 'city',
      label: t('contact.form.city'),
      maxLength: 100,
      rules: 'max:100',
      class: 'lg:col-span-2'
    },
    address: {
      type: 'text',
      name: 'address',
      label: t('contact.form.address'),
      maxLength: 255,
      rules: 'max:255'
    },
    comment: {
      type: 'text',
      name: 'comment',
      label: t('contact.form.comment'),
      maxLength: 500,
      rules: 'max:500'
    },
    package: {
      type: 'select',
      name: 'package',
      rules: 'required'
    }
  };

  const route = useRoute();

  const context = computed(() => {
    if (!route.params.slug) {
      return 'Főoldal';
    }

    return route.params.slug;
  });

  const updateFormLocale = () => {
    setLocale(locale.value);

    configure({
      generateMessage: localize({
        [locale.value]: {
          messages: (messages.value[locale.value] as any).validation ?? {},
          names: (messages.value[locale.value] as any).contact?.form ?? {},
          fields: {
            consentPrivacyPolicy: {
              required: t('contact.form.consentPrivacyPolicyRequired')
            }
          }
        }
      })
    });
  };

  watch(
    locale,
    () => {
      updateFormLocale();
    },
    { immediate: true }
  );

  return {
    fields,
    handleSubmit,
    context
  };
};
